import React from 'react'
import ReactPaginate from "react-paginate";
import { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
//import { Navigate, useNavigate } from 'react-router-dom';
import Notification from "../../Notification";
export default function CountryListing() {

    const [searchData, setsearchData] = useState('');
    const [items, setItems] = useState([]);
    // const [posts, setPosts] = useState([]);
    const [totalPages, setTotalPage] = useState(0);
    const [pageCount, setpageCount] = useState(0);
    const [loading, setLoading] = useState(false)
    const [delCountryList, setdelCountryList] = useState('');
    const [isChecked, setisChecked] = useState(false);
    // const [sorting, setSorting] = useState([]);
    const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' })
    const [viewMoreData, setviewMoreData] = useState([]);
    const [sortToggle, setSortToggle] = useState(true);
    const [perPage, setPerpage] = useState(process.env.REACT_APP_PER_PAGE);

    // let perPage = 2;
    // let currentPage="";


    useEffect(() => {
        console.log("process.env",process.env.REACT_APP_PER_PAGE);
        const getCountryList = async () => {
            const res = await Axios.get(`api/admin/list-country?pageNo=1&perPage=${perPage}`)
            // console.log(res)
            setItems(res.data.data.data);
            // console.log(res.data.data.data);
            // setFilterData(res.data.data.data)
            setTotalPage(res.data.data.totalPage)
            setpageCount(Math.ceil(res.data.data.totalPage));
            setLoading(false)
            // setItems(posts);
            localStorage.removeItem('sort_key');
            localStorage.removeItem('sort_order');
        };
        getCountryList();
    }, [perPage,]);

    if (loading && items.length === 0) {
        return <h2>Loading...</h2>
    }
    const fetchCountryList = async (currentPage) => {
        const sort_key = localStorage.getItem('sort_key');
        const sort_order = localStorage.getItem('sort_order');
        let sortUrl = "";
        if (sort_key && sort_order) {
            sortUrl = `&sortkey=${sort_key}&order=${sort_order}`;
        }
        const res = await Axios.get(`api/admin/list-country?pageNo=${currentPage}&perPage=${perPage}${sortUrl}`)
        // console.log(res)

        await setItems(res.data.data.data);
        return items;
    };

    const handlePageClick = async (items) => {
        console.log(items.selected);

        let currentPage = items.selected + 1;
        if (searchData !== "") {

            await searchHandle(currentPage);

        } else {

            await fetchCountryList(currentPage);
        }


    };
    const handleChange = (e) => {
        // alert("Hi");
        const { name, checked } = e.target;

        if (name === "allSelect") {
            let tempItems = items.map((countryList) => {
                return { ...countryList, isChecked: checked };
            });
            //   console.log(tempItems)
            //   return false;
            setisChecked(tempItems)
            setItems(tempItems);
        }
        else {
            let tempItems = items.map((countryList) =>
                countryList.country_id === name ? { ...countryList, isChecked: checked } : countryList
            );
            // console.log(tempItems)
            //   return false;
            setisChecked(tempItems)
            setItems(tempItems);

        }
    }
    const alldelete = async (e) => {

        const status = e.target.value
        let cntryDataLength = isChecked.length;
        let countryIdArray = [];
        if (cntryDataLength > 0) {
            for (let i = 0; i < cntryDataLength; i++) {
                console.log(isChecked[i]);
                if (isChecked[i].isChecked === true) {
                    let countryID = isChecked[i].country_id;
                    countryIdArray.push({ country_id: countryID });
                }
            }
        }

        if (isChecked) {
            const res = await Axios.post(`api/admin/update-country-status`, { country_id: countryIdArray, action_status: status });
            setdelCountryList(res.data)
            console.log(delCountryList);
            setNotify({
                isOpen: true,
                messsage: `Country has been ${status} successfully!`,
                type: 'success',

            })
            window.location.reload(false);

        }
        else {
            alert("please Select at least one check box !");
            //console.log("hii");
        }
    }


    const searchHandle = async (currentPage) => {

        if (searchData !== "") {
            const res = await Axios.get(`api/admin/list-country?pageNo=${currentPage}&perPage=${perPage}&searchData=${searchData}`)

            if (res.data.data.data.length > 0) {
                setItems(res.data.data.data)
                setTotalPage(res.data.data.totalPage)
                setpageCount(Math.ceil(res.data.data.totalPage));
            } if (res.data.data.data.length <= 0) {
                setItems([])
                setTotalPage(res.data.data.totalPage)
                setpageCount(Math.ceil(res.data.data.totalPage));
            }

        } else {
            setNotify({
                isOpen: true,
                messsage: `Search By and Search Value Should Not Be Blank!`,
                type: 'error',

            })
        }

    }

    const handleSortdesc = async (sortkey, order) => {
        if (sortkey) {
            // alert('I am Decending')
            console.log(sortkey)
            setSortToggle(true);
            localStorage.setItem("sort_key", sortkey)
            localStorage.setItem("sort_order", order)
            const res = await Axios.get(`api/admin/list-country?pageNo=1&perPage=${perPage}&sortkey=${sortkey}&order=${order}`)
            if (res.data.data.data.length > 0) {
                setItems(res.data.data.data);
                // setSortToggle(true);
            }
        }
    }

    const handleSortasc = async (sortkey, order) => {
        if (sortkey) {
            console.log(sortkey)
            // alert('I am accending')
            setSortToggle(false);
            localStorage.setItem("sort_key", sortkey)
            localStorage.setItem("sort_order", order)
            const res = await Axios.get(`api/admin/list-country?pageNo=1&perPage=${perPage}&sortkey=${sortkey}&order=${order}`)
            if (res.data.data.data.length > 0) {
                setItems(res.data.data.data);



            }
        }
    }
    const viewMore = async (country_id) => {
        alert('hii');
        const status = country_id;
        console.log('hii', status);
        const res = await Axios.get(`api/admin/list-country?country_id=${country_id}`)
        setviewMoreData(res.data.data.data[0])
        console.log(res.data.data.data[0]);
    }
    return (
        <>
            <div className="content-page">
                <div className="content">
                    {/* <h1>{totalPages}</h1> */}
                    {/* <!-- Start Content--> */}
                    <div className="container-fluid">

                        {/* <!-- start page title --> */}
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    {/* <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><a href="javascript: void(0);">Techzoni</a></li>
                                        <li className="breadcrumb-item"><a href="javascript: void(0);">Tables</a></li>
                                        <li className="breadcrumb-item active">Datatable</li>
                                    </ol>
                                </div> */}
                                    <h4 className="page-title">Country List</h4>
                                </div>
                            </div>
                        </div>
                        {/* <!-- end page title -->  */}

                        <div className="row">

                            <div className='col-md-6'>
<div className='business_head'>
<button className="btn btn-danger" type="button" value="Deleted" onClick={(e) => alldelete(e)} >DELETE</button>
                                    <button className="btn btn-primary" type="button" value="Active" onClick={(e) => alldelete(e)}  >Active All</button>
                                    <button className="btn btn-primary" type="button" value="Inactive" onClick={(e) => alldelete(e)}>Inactive All</button>
</div>
                            </div>
                            <div className='col-md-6'>
                            
   <div className='business_head business_head_rigt'>
   {
                                        notify.isOpen ?
                                            <Notification
                                                notify={notify}
                                                setNotify={setNotify} />
                                            : ""
                                    }
                                    <input type="" className='search-country-list' placeholder='Search...'
                                        onChange={(e) => setsearchData(e.target.value)}
                                    />
                                    <button type="Search" className="find-list" onClick={searchHandle}>Search</button>
   </div>
                            </div>
                            <div className="col-12">
                                <div className="tble-row table-responsive"> 
                                   
                                    <table id="datatable" className="table table-bordered  dt-responsive nowrap" style={{ padding: "30px", margin: "20px" }}>
                                        <thead>
                                            <tr>
                                                <th><input
                                                    type="checkbox"

                                                    name="allSelect"
                                                    checked={!items.some((countryList) => countryList?.isChecked !== true)}
                                                    onChange={handleChange} /> <label className="form-check-label ms-2">All Select</label></th>

                                                <th>S.No</th>
                                                <th >Country ID
                                                    {sortToggle ? (
                                                        <i id="country_id_up" onClick={() => handleSortasc("country_id", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i id="country_id_down" onClick={() => handleSortdesc("country_id", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>

                                                <th >Country Name
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("country_name", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("country_name", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th >Country Code
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("country_code", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("country_code", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th >Modified Date
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("modified_date", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("modified_date", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th >Added Date
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("added_date", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("added_date", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th >Date Time Stamp
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("date_time_stamp", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("date_time_stamp", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th >Added By

                                                </th>
                                                <th >Status
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("status", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("status", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {items.map((countryList, index) =>
                                                <tr key={index}>
                                                    <td><input
                                                        type="checkbox"
                                                        name={[countryList.country_id]}
                                                        checked={countryList?.isChecked || false}
                                                        onChange={handleChange}
                                                    />  </td>
                                                    <td>{index + 1}</td>
                                                    <td>{countryList.country_id}</td>
                                                    <td>{countryList.country_name}</td>
                                                    <td>{countryList.country_code}</td>
                                                    <td>{countryList.modified_date}</td>
                                                    <td>{countryList.added_date}</td>
                                                    <td>{countryList.date_time_stamp}</td>
                                                    <td>{countryList.added_by}</td>
                                                    <td>{countryList.status}</td>
                                                    <td><button
                                                        type="button" className="btn btn-primary"
                                                        data-toggle="modal"
                                                        data-target="#exampleModalCenter"
                                                        value={countryList.country_id}
                                                        onClick={(e) => viewMore(e.target.value)}
                                                    >
                                                        View More</button></td>
                                                </tr>)}
                                        </tbody>
                                    </table>
                                    <div className="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="exampleModalLongTitle">COUNTRY LIST</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="container">
                                                        <div className="row">
                                                            <div className="col-md-6 col-lg-6 col-xl-6">
                                                                <p><strong>S.No:</strong></p>
                                                                <p><strong>country_id:-{viewMoreData.country_id}</strong></p>
                                                                <p><strong>country_name:-{viewMoreData.country_name}</strong></p>
                                                                <p><strong>country_code:-{viewMoreData.country_code}</strong></p>
                                                                <p><strong>modified_date:-{viewMoreData.modified_date}</strong></p>
                                                                {/* <p><strong>lsat name</strong>:</p>
                                                                <p><strong>tag name</strong>:</p> */}

                                                            </div>

                                                            <div className="col-md-6 col-lg-6 col-xl-6">

                                                                <p><strong>added_date:-{viewMoreData.added_date}</strong></p>
                                                                <p><strong>date_time_stamp:-{viewMoreData.date_time_stamp}</strong></p>
                                                                <p><strong>added_by:-{viewMoreData.added_by}</strong></p>
                                                                <p><strong>status:-{viewMoreData.status}</strong></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                    <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                                    <button type="button" className="btn btn-primary">Save changes</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ReactPaginate
                                        previousLabel={"previous"}
                                        nextLabel={"next"}
                                        breakLabel={"..."}
                                        pageCount={pageCount}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={3}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination justify-content-center"}
                                        pageClassName={"page-item"}
                                        pageLinkClassName={"page-link"}
                                        previousClassName={"page-item"}
                                        previousLinkClassName={"page-link"}
                                        nextClassName={"page-item"}
                                        nextLinkClassName={"page-link"}
                                        breakClassName={"page-item"}
                                        breakLinkClassName={"page-link"}
                                        activeClassName={"active"}
                                    />
                                    <div className='slect-pg-row'>
                                        <span><b>Rows per page:-</b></span>    
                                        
                                        <select name="Rows per page" className="item-page" onChange={(e) => setPerpage(e.target.value)}>
                                            <option value="">Select Item Per Page</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="30">30</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="200">200</option>
                                        </select>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* <!-- end row --> */}
                    </div>
                    {/* <!-- end container-fluid --> */}

                </div>
            </div>
        </>
    )
}
